<template>
  <div class="modal" v-if="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main">
      <div class="title-area" id="modal-moving">
       <div
        class="cross_btn"
        @click="modalShown = false"
        >
          <span class="css-cancel"></span>
        </div>
        <h2>現在編集中のデータを保存しますか？</h2>
      </div>
      <div class="select-space">
        <ul>
          <li>
            <button class="main_btn btn_wid" @click="modalShown = false; $emit('saveFileData')">上書き保存</button>
            <button class="main_btn btn_wid" @click="modalShown = false; $emit('onSaveAs', fileData.topSpaceModel.spaceObjectType, fileData.spaceJoincd)">名前を付けて保存</button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SelectUpdateInsertModal',
  props: {
    fileData: Object
  },
  data () {
    return {
      modalShown: false
    }
  },
  methods: {
    showModal: function () {
      this.modalShown = true
    }
  }
}
</script>
<style scoped>
li {
  line-height: 80px
}
.title-area {
  display: flex;
}
h2{
  margin: auto;
  padding-right: 29px;
}
.modal .modal-main .select-space {
  text-align: center;
  line-height: 40px;
}
.btn_wid {
  min-width: 90px;
}
/*==== 閉じるボタン ====*/
.cross_btn {
  width:19px;
  height:19px;
  padding: 3px 4px;
  /* position: absolute; */
  top:20px;
  left:30px;
  border: 1px solid #ff4500;
}
.cross_btn:hover {
  cursor: pointer;
}
.css-cancel {
  display: inline-block;
  position: relative;
  margin: 0 20px 0 7px;
  padding: 0;
  width: 3px;
  height: 20px;
  background: #000;
  transform: rotate(45deg);
  background: #ff4500;
}
.css-cancel:before {
  display: block;
  content: "";
  position: absolute;
  top: 50%;
  left: -8px;
  width: 20px;
  height: 3px;
  margin-top: -2px;
  background: #000;
  background: #ff4500;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/modal/SelectUpdateInsertModal.vue